<template>
  <div>
    <div class="link-warp">
      <div class="link-item active">资金提现</div>
      <Button class="goback btn-height45" to="/user/finance/account"
        >返回</Button
      >
    </div>
    <div class="tips-warn">
      <div>请仔细阅读以下内容：</div>
      <div>
        1、银行卡账号主要用来充值或者提现使用，您添加输入与您身份证姓名一致的绑定银行卡号，否则提现审核失败!。
      </div>
      <div>
        2、如充值遇到问题请拨打客服电话：<span style="color: #ff5c35"
          >400-8788-585</span
        >或在线客服微信<span style="color: #ff5c35">18922836153</span
        >（手机微信同号）。
      </div>
    </div>

    <div class="section" style="position: relative">
      <loading :loading="loading" style="z-index: 11"></loading>
      <div>
        账户可用金额： <span style="color: #ff5c35">{{ balance }}</span> 元
      </div>
      <div class="col">
        <div class="name">提现金额</div>
        <div class="label row">
          <Input
            class="height45"
            v-model="form.amount"
            placeholder="请输入提现金额"
            style="width: 200px"
            clearable
            @on-keyup="onAmountKeyUp"
          />
          <div style="margin-left: 10px">
            元，<span
              style="color: #219fdb; margin: 0 10px; cursor: pointer"
              @click="form.amount = balance"
              >全部提现</span
            >提现手续费：
            <span style="color: #ff5c35; margin: 0 10px; cursor: pointer">{{
              drawCommission
            }}</span>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="name">提现账号</div>
        <div class="label row">
          <Select
            v-model="form.bankValue"
            style="width: 306px"
            filterable
            @on-select="bankChange"
          >
            <Option
              v-for="item in backList"
              :key="item.id"
              :value="item.id"
              :label="item.bankName + ' - ' + item.cardNumber"
            >
              <div>
                <p class="bank-font bank-number">{{ item.bankName }}</p>
                <p class="bank-font">{{ item.cardNumber }}</p>
              </div>
            </Option>
          </Select>
          <Button
            style="margin-left: 20px"
            class="btn-height45"
            @click="addBackModalVisibility = true"
            >+ 新增银行卡</Button
          >
          <Button
            style="margin-left: 20px"
            class="btn-height45"
            @click="backListModalVisibility = true"
            >我的银行卡</Button
          >
        </div>
      </div>
      <Button
        class="btn-height45"
        type="primary"
        :loading="loading"
        @click="onConfirm"
        >申请提现</Button
      >
    </div>
    <!-- 我的提现记录 -->
    <div class="section">
      <div class="table-data">
        <div class="total">提现记录（{{ total }}）</div>
        <Table
          class="domain-table"
          :columns="columns"
          :data="data"
          :loading="tableLoading"
        >
          <template slot="status" slot-scope="{ row }">
            <div>
              {{ row.status | status }}
            </div>
          </template>
          <template slot="action" slot-scope="{ row }">
            <Button v-if="row.status === 0" @click="onCancel(row.id)"
              >取消申请</Button
            >
            <Button v-else-if="row.status === 4" @click="showReason(row)"
              >查看原因</Button
            >
            <div v-else>--</div>
          </template>
        </Table>
        <div class="page-tool">
          <Page
            :current="page"
            :total="total"
            :page-size="limit"
            @on-change="onPageChange"
          />
        </div>
      </div>
    </div>
    <addBackModal
      :show.sync="addBackModalVisibility"
      @submit-success="onSuccess"
    ></addBackModal>
    <backListModal
      :show.sync="backListModalVisibility"
      @on-reload="reload"
    ></backListModal>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import addBackModal from "components/back/addBackModal.vue";
import backListModal from "components/back/backListModal.vue";
import loading from "components/loading.vue";
import {
  bankCardList,
  userLevel,
  withdraw,
  withdrawalPageList,
  cancelCashOut,
} from "api/user.js";
import { accMul, toFixedDigit } from "utils/index.js";
export default {
  name: "cashout",
  components: {
    addBackModal,
    backListModal,
    loading,
  },
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "待审核";
          break;
        case 1:
          title = "待转账";
          break;
        case 2:
          title = "转账成功";
          break;
        case 3:
          title = "转账失败";
          break;
        case 4:
          title = "审核失败";
          break;
        case 5:
          title = "用户取消";
          break;
      }
      return title;
    },
  },
  computed: {
    ...mapState(["freezeAmount", "balance"]),
    drawCommission() {
      if (
        this.levelRatio != null &&
        this.form.amount != null &&
        this.form.amount !== "" &&
        !isNaN(this.form.amount)
      ) {
        return accMul(this.form.amount, this.levelRatio) + "元";
      }
      return "";
    },
  },
  data() {
    return {
      form: {
        amount: "",
        bankValue: "",
        banKLabel: "",
      },
      typeList: [],
      columns: [
        {
          title: "提现日期",
          align: "center",
          key: "createdTime",
        },
        {
          title: "提现银行",
          align: "center",
          key: "bankName",
        },
        {
          title: "提现账号（后4位）",
          align: "center",
          key: "cardNo",
        },
        {
          title: "提现金额",
          align: "center",
          key: "payable",
        },
        {
          title: "提现状态",
          align: "center",
          slot: "status",
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
        },
      ],
      page: 1,
      total: 0,
      limit: 20,
      data: [],
      loading: false,
      tableLoading: false,
      addBackModalVisibility: false,
      backListModalVisibility: false,
      backList: [], // 银行卡列表
      levelRatio: 0, // 提现手续费
    };
  },
  created() {
    this.getBankCardList();
    this.getCashOutLevel();
    this.onPageChange(1);
  },
  methods: {
    ...mapMutations(["MUT_BALANCE"]),
    ...mapActions(["ACT_AMOUNT_INFO"]),
    onAmountKeyUp() {
      this.form.amount = this.form.amount.replace(/[^\d^\.]+/g, "");
    },
    // 获取银行卡列表
    async getBankCardList() {
      const params = {
        limit: 99999,
        page: 1,
      };
      const res = await bankCardList(params);
      if (res.code === 200) {
        this.backList = res.data.list;
      }
    },
    // 获取提现手续费比例
    async getCashOutLevel() {
      const res = await userLevel();
      if (res.code === 200) {
        this.levelRatio = res.data.serviceRate * 0.01;
      }
    },
    // 选择的银行卡改变
    bankChange(item) {
      this.banKLabel = item.label;
      this.bankValue = item.value;
    },
    // 确认提现
    onConfirm() {
      if (this.balance <= 0) {
        this.$Message.warning("账户里没有可用金额！");
        return;
      }
      if (!this.form.amount) {
        this.$Message.warning("请输入提现金额！");
        return;
      }
      if (!this.form.bankValue) {
        this.$Message.warning("请选择银行账号！");
        return;
      }
      this.$Modal.confirm({
        title: "提现确认",
        content: `
          <p>确定要提现<span style="padding:0 5px; color: #f9521f">${
            this.form.amount
          }元</span>至</p>
          <p style="margin:8px 0;"><span style="color: #2d8cf0">${
            this.banKLabel
          }</span>吗？</p>
          <p style="text-align:right;">手续费<span style="color: #f9521f">${accMul(
            this.form.amount,
            this.levelRatio
          )}元</span></p>
        `,
        onOk: async () => {
          this.loading = true;
          const data = {
            bankCardId: this.bankValue,
            amount: this.form.amount,
          };
          try {
            const res = await withdraw(data);
            if (res.code === 200) {
              this.$Message.success("申请成功！");
              this.MUT_BALANCE(
                parseFloat(
                  toFixedDigit(
                    parseFloat(this.balance) - parseFloat(this.form.amount),
                    2
                  )
                )
              );
              this.form.amount = "";
              this.form.bankValue = null;
              this.form.banKLabel = "";
              this.onPageChange(1);
            }
            this.loading = false;
          } catch (error) {
            this.loading = false;
          }
        },
      });
    },
    // 请求
    async req_getList() {
      try {
        const params = {
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await withdrawalPageList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 分页
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
    // 取消申请
    async onCancel(id) {
      this.$Modal.confirm({
        title: "取消确认",
        content: "<p>确定要取消此提现申请吗？</p>",
        onOk: async () => {
          try {
            const res = await cancelCashOut(id);
            const { code, result } = res;
            if (code === 200 && result) {
              await this.ACT_AMOUNT_INFO();
              this.$Message.success("取消成功！");
              this.onPageChange(1);
            }
          } catch (error) {
            console.log(error);
          }
        },
      });
    },
    // 添加银行卡回调
    async onSuccess(callback) {
      await this.getBankCardList();
      callback(callback);
    },
    // 刷新银行卡列表
    async reload(val) {
      if (val) {
        await this.getBankCardList();
      }
    },
    // 查看原因
    showReason(val) {
      this.$Modal.confirm({
        title: "审核失败原因",
        content: val.reason,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.link-warp {
  position: relative;
  background-color: #fff;
  padding: 0 30px;
  .link-item {
    display: inline-block;
    height: 80px;
    line-height: 80px;
    margin: 0 30px;
    color: #333;
    font-size: 20px;
    font-weight: 400;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      width: 0;
      height: 3px;
      background-color: transparent;
      transition: all 0.3s;
    }
  }
  .link-item.active {
    color: #3992e9;
    font-weight: bold;
    &::before {
      width: 100%;
      background-color: #3992e9;
    }
  }
  .goback {
    position: absolute;
    top: 50%;
    right: 60px;
    transform: translateY(-50%);
  }
}
.tips-warn {
  padding: 28px 50px;
  border-radius: 8px;
  color: #333333;
  font-size: 14px;
  background-color: #e9effd;
  border: 1px solid #3992e9;
  margin: 50px;
}
.section {
  background-color: #fff;
  border-radius: 8px;
  margin: 50px;
  padding: 50px;
}
.col {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
  .name {
    color: #333333;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .label {
    color: #999999;
  }
}
.row {
  display: flex;
  align-items: center;
}
.total {
  line-height: 80px;
  font-size: 18px;
  color: #3992e9;
  font-weight: bold;
}
// .table-data {
//   margin: 40px 0;
//   background-color: #fff;
//   padding: 20px 20px;
// }
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #f0f3f6;
  }
  .ivu-table-header th,
  .ivu-table-body td {
    height: 80px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
